import create from 'zustand';

/** type declaration for user details */
type UserDetails = {
    first_name: string;
    last_name: string;
    usercred: string;
};

/** interface declaration for user store to manage user states globally */
interface UserStore {
    details: UserDetails;
    setDetails: (details: UserDetails) => void;
}

/** user store to manage user states globally */
const useUserStore = create<UserStore>((set) => ({
    details: { first_name: '', last_name: '', usercred: '' },
    setDetails: (details) => {
        set({ details });
    },
}));

export default useUserStore;
